var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup70(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 413,
    height: 162,
    viewBox: "0 0 413 162",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_12_6928)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 216.5,
    cy: 3.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 216.5,
    cy: 24.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 216.5,
    cy: 45.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 216.5,
    cy: 66.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 216.5,
    cy: 87.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 216.5,
    cy: 108.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 216.5,
    cy: 129.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 216.5,
    cy: 150.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 237.5,
    cy: 3.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 237.5,
    cy: 24.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 237.5,
    cy: 45.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 237.5,
    cy: 66.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 237.5,
    cy: 87.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 237.5,
    cy: 108.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 237.5,
    cy: 129.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 237.5,
    cy: 150.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.5,
    cy: 3.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.5,
    cy: 24.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.5,
    cy: 45.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.5,
    cy: 66.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.5,
    cy: 87.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.5,
    cy: 108.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.5,
    cy: 129.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 258.5,
    cy: 150.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 279.5,
    cy: 3.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 279.5,
    cy: 24.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 279.5,
    cy: 45.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 279.5,
    cy: 66.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 279.5,
    cy: 87.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 279.5,
    cy: 108.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 279.5,
    cy: 129.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 279.5,
    cy: 150.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 300.5,
    cy: 3.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 300.5,
    cy: 24.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 300.5,
    cy: 45.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 300.5,
    cy: 66.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 300.5,
    cy: 87.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 300.5,
    cy: 108.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 300.5,
    cy: 129.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 300.5,
    cy: 150.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 321.5,
    cy: 3.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 321.5,
    cy: 24.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 321.5,
    cy: 45.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 321.5,
    cy: 66.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 321.5,
    cy: 87.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 321.5,
    cy: 108.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 321.5,
    cy: 129.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 321.5,
    cy: 150.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 342.5,
    cy: 3.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 342.5,
    cy: 24.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 342.5,
    cy: 45.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 342.5,
    cy: 66.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 342.5,
    cy: 87.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 342.5,
    cy: 108.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 342.5,
    cy: 129.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 342.5,
    cy: 150.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 363.5,
    cy: 3.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 363.5,
    cy: 24.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 363.5,
    cy: 45.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 363.5,
    cy: 66.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 363.5,
    cy: 87.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 363.5,
    cy: 108.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 363.5,
    cy: 129.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 363.5,
    cy: 150.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 384.5,
    cy: 3.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 384.5,
    cy: 24.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 384.5,
    cy: 45.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 384.5,
    cy: 66.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 384.5,
    cy: 87.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 384.5,
    cy: 108.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 384.5,
    cy: 129.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 384.5,
    cy: 150.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 405.5,
    cy: 3.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 405.5,
    cy: 24.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 405.5,
    cy: 45.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 405.5,
    cy: 66.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 405.5,
    cy: 87.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 405.5,
    cy: 108.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 405.5,
    cy: 129.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 405.5,
    cy: 150.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 3.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 24.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 45.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 66.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 87.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 108.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 129.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 150.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 3.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 24.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 45.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 66.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 87.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 108.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 129.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 28.5,
    cy: 150.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.5,
    cy: 3.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.5,
    cy: 24.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.5,
    cy: 45.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.5,
    cy: 66.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.5,
    cy: 87.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.5,
    cy: 108.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.5,
    cy: 129.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 49.5,
    cy: 150.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.5,
    cy: 3.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.5,
    cy: 24.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.5,
    cy: 45.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.5,
    cy: 66.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.5,
    cy: 87.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.5,
    cy: 108.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.5,
    cy: 129.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 70.5,
    cy: 150.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 91.5,
    cy: 3.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 91.5,
    cy: 24.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 91.5,
    cy: 45.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 91.5,
    cy: 66.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 91.5,
    cy: 87.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 91.5,
    cy: 108.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 91.5,
    cy: 129.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 91.5,
    cy: 150.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112.5,
    cy: 3.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112.5,
    cy: 24.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112.5,
    cy: 45.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112.5,
    cy: 66.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112.5,
    cy: 87.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112.5,
    cy: 108.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112.5,
    cy: 129.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 112.5,
    cy: 150.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 133.5,
    cy: 3.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 133.5,
    cy: 24.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 133.5,
    cy: 45.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 133.5,
    cy: 66.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 133.5,
    cy: 87.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 133.5,
    cy: 108.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 133.5,
    cy: 129.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 133.5,
    cy: 150.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.5,
    cy: 3.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.5,
    cy: 24.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.5,
    cy: 45.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.5,
    cy: 66.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.5,
    cy: 87.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.5,
    cy: 108.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.5,
    cy: 129.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 154.5,
    cy: 150.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 175.5,
    cy: 3.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 175.5,
    cy: 24.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 175.5,
    cy: 45.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 175.5,
    cy: 66.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 175.5,
    cy: 87.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 175.5,
    cy: 108.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 175.5,
    cy: 129.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 175.5,
    cy: 150.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 196.5,
    cy: 3.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 196.5,
    cy: 24.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 196.5,
    cy: 45.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 196.5,
    cy: 66.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 196.5,
    cy: 87.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 196.5,
    cy: 108.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 196.5,
    cy: 129.5,
    r: 3.5,
    fill: "#E7F0FC"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 196.5,
    cy: 150.5,
    r: 3.5,
    fill: "#E7F0FC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_12_6928",
    x: 0,
    y: 0,
    width: 413,
    height: 162,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_12_6928"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_12_6928",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup70);
export default __webpack_public_path__ + "static/media/Group 70.9ff2dd3d04448193e0959bb652925457.svg";
export { ForwardRef as ReactComponent };